import { render, staticRenderFns } from "./PageStadiumChats.vue?vue&type=template&id=6cab47f2&"
import script from "./PageStadiumChats.vue?vue&type=script&lang=js&"
export * from "./PageStadiumChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cab47f2')) {
      api.createRecord('6cab47f2', component.options)
    } else {
      api.reload('6cab47f2', component.options)
    }
    module.hot.accept("./PageStadiumChats.vue?vue&type=template&id=6cab47f2&", function () {
      api.rerender('6cab47f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageStadiumChats.vue"
export default component.exports